import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames/bind";
import styles from "./Menu.module.scss";

export const Menu = ({ children, className }) => {

    const cx = classNames.bind(styles);

    const classes = cx(
        "wrapper",
        className
    );

    return (
        <nav className={classes}>
            { children }
        </nav>
    )
}

Menu.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};